/*
 * @Author: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-06-10 18:21:40
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2023-10-16 18:18:01
 * @FilePath: \fe-crm\src\store\modules\schedule.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { publicService } from '@/api/';
import { defineStore } from 'pinia';
// import { tools } from '@/utils/tools';
import { Message } from '@arco-design/web-vue';
import i18n from '@/locales/index';
export const useScheduleStore = defineStore('getSchedule', {
  state: () => ({
    finishDetail: [],
    nofinishDetail: []
  }),
  actions: {
    // 获取日程列表
    getScheduleList(params) {
      console.log(21, params);
      this.finishDetail = [];
      this.nofinishDetail = [];
      return new Promise((resolve, reject) => {
        publicService
          .getCalenderDetailByStatus(params)
          .then((res) => {
            this.finishDetail = res.result?.finishDetail;
            this.nofinishDetail = res.result?.nofinishDetail;
            if (res.error) {
              Message.error(res.error?.msg || i18n.global.t('操作失败'));
            }
            resolve(res);
          })
          .catch((err) => {
            // Message.error(err.message || err.statusText || '日程数据获取失败');
            reject(err);
          });
      });
    },
    //新建日程
    addCreatEvent(params, cb) {
      return new Promise((resolve, reject) => {
        publicService
          .addCreatEvent(params)
          .then((res) => {
            if (!res.error) {
              Message.success(i18n.global.t('操作成功'));
              cb && cb();
            } else {
              Message.error(res.error?.msg || i18n.global.t('操作失败'));
            }
            resolve(res);
          })
          .catch((e) => {
            Message.error(e.message || e.statusText || i18n.global.t('操作失败'));
            reject(e);
          });
      });
    },
    //编辑日程
    updateCreatEvent(params, cb) {
      return new Promise((resolve, reject) => {
        publicService
          .updateCalender(params)
          .then((res) => {
            if (!res.error) {
              Message.success(i18n.global.t('操作成功'));
              cb && cb();
            } else {
              Message.error(res.error?.msg || i18n.global.t('操作失败'));
            }
            resolve(res);
          })
          .catch((e) => {
            Message.error(e.message || e.statusText || i18n.global.t('操作失败'));
            reject(e);
          });
      });
    },
    //删除日程
    async deleteCalender(params, cb) {
      try {
        const res = await publicService.deleteCalender(params);
        if (!res.error) {
          Message.success(i18n.global.t('操作成功'));
          cb && cb();
        } else {
          Message.error(res.error?.msg || i18n.global.t('操作失败'));
        }
      } catch (e) {
        Message.error(e.message || e.statusText || i18n.global.t('操作失败'));
      }
    }
  }
});
export default useScheduleStore;
